module.exports = __webpack_public_path__ + "ddac3c294705433e561258f886ba4751.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/green_dust_scratch.png
// module id = 1011
// module chunks = 0